// CustomSelect1.js
import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, Box, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const CustomSelect1 = ({ label, value, onChange, options, open, setOpen, getOptionLabel }) => {
  return (
    <FormControl variant="outlined" size="small" sx={{ minWidth: 120, marginRight: 1 }}>
      <InputLabel>{label}</InputLabel>
      <Select
        multiple
        value={value}
        onChange={(e) => onChange(e.target.value)} // Ensure this updates the state correctly
        label={label}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        renderValue={(selected) => selected.join(', ')}
        MenuProps={{
          PaperProps: {
            sx: {
              maxHeight: 500,
              overflow: 'auto',
            },
          },
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 1, py: 0.5 }}>
          <Typography variant="subtitle2">{label}</Typography>
          <IconButton
            edge="end"
            size="small"
            onClick={(e) => {
              e.stopPropagation(); // Prevent menu from reopening
              setOpen(false);
            }}
            aria-label={`Close ${label} dropdown`}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
        {options.map((option) => (
          <MenuItem key={getOptionLabel(option)} value={getOptionLabel(option)}>
            {getOptionLabel(option)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CustomSelect1;
